module.exports = __webpack_public_path__ + "img/no-data-illustration.808c8de8.svg";